import { ChevronRightIcon } from "lucide-react";
import type { ReactNode } from "react";
import { Disclosure, DisclosurePanel, Heading } from "react-aria-components";

import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";
import { cn } from "@/components/ui/utils";

export function DetailSection({
  title,
  badge,
  children,
  actions,
  hideBorder = false,
}: {
  title: string;
  badge?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
  hideBorder?: boolean;
}) {
  return (
    <Disclosure defaultExpanded className="w-full group">
      <Heading
        tabIndex={-1}
        className={cn(
          "flex items-center justify-between pr-3",
          !hideBorder ? "border-b" : "",
        )}
        slot="trigger"
      >
        <Button variant="ghost" size="sm" slot="trigger" className="mb-1">
          <Text
            size="2"
            muted
            className="cursor-pointer flex items-center gap-2"
          >
            <ChevronRightIcon className="size-4 transition-all group-data-[expanded=true]:rotate-90" />
            {title}
            {badge}
          </Text>
        </Button>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </Heading>
      <DisclosurePanel>{children}</DisclosurePanel>
    </Disclosure>
  );
}
